<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="440px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item prop="name" label="假日名称" >
                        <el-input v-model="form.name" maxlength="200"  placeholder="" style="width:195px;"></el-input>
                    </el-form-item>

                    <el-form-item prop="" label="节假日日期">
                        <el-button type="primary"  size="mini" icon="el-icon-plus" @click="setAddDate()">新增</el-button>
                        <el-table
                            :data="dates"
                            height="150"
                            border
                            style="width: 330px;">
                            <el-table-column prop="date" label="日期" width="180"> </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button style="color: red" @click.native.prevent="delDate(scope.$index)"
                                        type="text"
                                        size="small">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
         <!-- 日期弹出框 -->
        <div v-if="addDateVisible">
            <addDate ref="addDate"></addDate>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import addDate from './AddDate.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                addDateVisible:false,
                form:{
                    name:"",
                    id:""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入假日名称', trigger: 'blur' }
                    ]
                },
                dates:[]
            }
        },
        components: {
            addDate
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.name=data.name;
                this.form.id=data.id;
                // 获取节假日期
                this.getDate(data.id);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 节假日期
            getDate(id){
                let url  = this.listHolidaysDateUrl;
                let data = {legalHolidaysId:id};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.dates = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 日期段操作
            setAddDate(){
                this.addDateVisible=true;
                this.$nextTick(() => {
                    this.$refs['addDate'].init();
                })
            },
            addDate(data){
                this.dates.push(data);
            },
            delDate(index){
                this.dates.splice(index, 1);
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.holidaysUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            dates:JSON.stringify(this.dates)
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/attendance/holidays/Update.vue